import React, { Component } from 'react';
import autoBind from 'react-autobind/src/autoBind';
import TableHelper from 'src/utils/table-helper';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { dateTimeFormatter, priceFormatter } from 'src/utils/formatters';
import { sortMoney } from 'src/utils/currency';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';

class OrganizationTasksTable extends Component {
    constructor(props) {
        super(props);

        autoBind(this);

        this.tableHelper = new TableHelper();

        this.state = {
            selectedCurrency: 'EUR',
        };
    }

    render() {
        const { tasks, t } = this.props;

        const tableData = [];
        let provisions = [];

        const doneTasks = [];
        const futureTasks = [];

        if (tasks && tasks.length > 0) {
            tasks.map(task => {
                if (task.done) {
                    doneTasks[task.price.currency] = (doneTasks[task.price.currency] || 0) + task.price.amount;
                } else {
                    futureTasks[task.price.currency] = (futureTasks[task.price.currency] || 0) + task.price.amount;
                }

                if (task.provision && task.provision.currency !== undefined)
                    provisions[task.provision.currency] =
                        (provisions[task.provision.currency] || 0) + task.provision.amount;

                tableData.push({
                    id: task.id,
                    identifier: task.identifier,
                    bookingIdentifier: task.bookingIdentifier,
                    taskFrom: task.taskFrom.location.address,
                    taskTo: task.taskTo.location.address,
                    departureTime: task.taskFrom.time,
                    arrivalTime: task.taskTo.time,
                    bookedAt: task.bookedAt,
                    price: task.price,
                    currency: task.price.currency,
                    customerEmail: task.customer.email,
                    companyName: task.company.companyName,
                    bookingIntegration: task.bookingIntegration,
                });
            });
        }

        const filterOptions = [...new Set([...Object.keys(doneTasks), ...Object.keys(futureTasks)])];

        if (tasks.length <= 0)
            return (
                <span>
                    <strong>{t('organization_tasks.no_bookings')}</strong>
                </span>
            );

        return (
            <>
                <div>
                    <div className="col-md-3">
                        <label htmlFor="currencyFilter" className="form-label">
                            {t('organization_tasks.filter_by_currency')}
                        </label>
                        <select
                            className="form-select"
                            id="currencyFilter"
                            onChange={e => {
                                this.setState({ ...this.state, selectedCurrency: e.target.value });
                            }}>
                            {filterOptions.map(key => (
                                <option key={key} value={key}>
                                    {key}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="row col-md-12">
                    <div className="col-md-3">
                        <strong>{t('organization_tasks.future_revenue')}:</strong>{' '}
                        {priceFormatter({
                            amount: futureTasks[this.state.selectedCurrency] || 0,
                            currency: this.state.selectedCurrency,
                        })}
                    </div>
                    <div className="col-md-3">
                        <strong>{t('organization_tasks.done_revenue')}:</strong>{' '}
                        {priceFormatter({
                            amount: doneTasks[this.state.selectedCurrency] || 0,
                            currency: this.state.selectedCurrency,
                        })}
                    </div>
                    <div className="col-md-3">
                        <strong>{t('organization_tasks.provision')}:</strong>{' '}
                        {priceFormatter({
                            amount: provisions[this.state.selectedCurrency] || 0,
                            currency: this.state.selectedCurrency,
                        })}
                    </div>
                </div>
                <div>
                    <div className="col-md-12">
                        <BootstrapTableErrorBoundary>
                            <BootstrapTable
                                Table
                                ref={ref => (this.table = ref)}
                                data={tableData}
                                exportCSV={true}
                                striped={true}
                                hover={true}
                                condensed={true}
                                pagination={true}
                                options={Object.assign(
                                    {},
                                    this.tableHelper.getOptions(tasks.length > 0, this.state.page, tableData.length),
                                )}
                                selectRow={Object.assign({}, this.tableHelper.getRowProps(this.state.selected))}
                                searchPlaceholder={t('common_phrases.search')}
                                search={true}>
                                <TableHeaderColumn
                                    columnTitle={true}
                                    dataField="id"
                                    hidden={!this.state.showCompanyIds}
                                    dataAlign="right"
                                    width="50"
                                    dataSort={true}
                                    isKey={true}
                                    export={true}>
                                    {t('common_phrases.id')}
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    columnTitle={true}
                                    dataField="bookingIdentifier"
                                    width="60"
                                    dataSort={true}>
                                    {t('booked_tasks.booking_number')}
                                </TableHeaderColumn>
                                <TableHeaderColumn columnTitle={true} dataField="identifier" width="60" dataSort={true}>
                                    {t('common_phrases.id')}
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    columnTitle={true}
                                    dataField="departureTime"
                                    width="160"
                                    dataFormat={dateTimeFormatter}
                                    dataSort={true}>
                                    {t('search_requests.from.time')}
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    columnTitle={true}
                                    dataField="arrivalTime"
                                    width="160"
                                    dataFormat={dateTimeFormatter}
                                    dataSort={true}>
                                    {t('search_requests.to.time')}
                                </TableHeaderColumn>
                                <TableHeaderColumn columnTitle={true} dataField="taskFrom" width="220" dataSort={true}>
                                    {t('search_requests.from.location')}
                                </TableHeaderColumn>
                                <TableHeaderColumn columnTitle={true} dataField="taskTo" width="220" dataSort={true}>
                                    {t('search_requests.to.location')}
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    columnTitle={true}
                                    dataField="companyName"
                                    width="13ß"
                                    dataSort={true}>
                                    {t('common_phrases.company')}
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    columnTitle={true}
                                    dataField="customerEmail"
                                    width="220"
                                    dataSort={true}>
                                    {t('booked_tasks.customer')}
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    columnTitle={true}
                                    dataField="price"
                                    width="100"
                                    dataFormat={priceFormatter}
                                    sortFunc={sortMoney}
                                    dataSort={true}>
                                    {t('task_details.price')}
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    columnTitle={false}
                                    dataField="bookingIntegration"
                                    width="50"
                                    dataFormat={bookingIntegrationFormatter}
                                    dataSort={true}>
                                    {t('administration.integration')}
                                </TableHeaderColumn>
                            </BootstrapTable>
                        </BootstrapTableErrorBoundary>
                    </div>
                </div>
            </>
        );
    }
}

export const bookingIntegrationFormatter = cell => {
    if (cell) return <span className="fa fa-check-circle-o text-success fa-lg" title={cell.name} />;
    else return <span className="fa fa-times-circle-o text-danger fa-lg" />;
};

export default OrganizationTasksTable;
